import Enum from './enum.json';
import Dashboard from './Dashboard.json';

export default { utils: { ...Enum, ...Dashboard } };
